import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'

function Screen ({ isFetching, children }) {
  const onClick = useCallback((e) => {
    if (isFetching) {
      e.preventDefault()
      e.stopPropagation()
    }
  }, [isFetching])

  const styles = useMemo(() => {
    return isFetching ? {
      opacity: 0.4,
      transition: 'opacity var(--transition-duration-short) var(--transition-easing-normal)',
      pointerEvents: isFetching ? 'none' : 'auto'
    } : {}
  }, [isFetching])

  return (
    <div style={styles} onClick={onClick}>
      {children}
    </div>
  )
}

Screen.propTypes = {
  children: PropTypes.node,
  isFetching: PropTypes.bool
}

export default Screen
